import { render, staticRenderFns } from "./p33.vue?vue&type=template&id=50a658a0&scoped=true&"
import script from "./p33.vue?vue&type=script&lang=js&"
export * from "./p33.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a658a0",
  null
  
)

export default component.exports